var _path, _line, _line2, _line3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcArrowNarrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ic-arrow-narrow-up",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    d: "M0,0H16V16H0Z",
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    y2: 10.126,
    transform: "translate(8.063 2.874)",
    fill: "none",
    stroke: "#28bf8d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    x1: 3,
    y1: 3,
    transform: "translate(8.078 2.902)",
    fill: "none",
    stroke: "#28bf8d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    y1: 3,
    x2: 3,
    transform: "translate(5.049 2.902)",
    fill: "none",
    stroke: "#28bf8d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowNarrowUp);
export default __webpack_public_path__ + "static/media/ic-arrow-narrow-up.f3177595.svg";
export { ForwardRef as ReactComponent };